(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var link = e.target.closest('.product-card__link[data-collection-handle]');
    if (!link) return;
    try {
      sessionStorage.setItem('breadcrumb_collection', JSON.stringify({
        handle: link.dataset.collectionHandle,
        title: link.dataset.collectionTitle,
        url: link.dataset.collectionUrl
      }));
    } catch (_) {}
  });
  } catch(e) { console.error(e); }
})();

})();
